import { api } from '@shared/config/axiosConfig';
import { buildEndpoint } from '@shared/utils/buildEndpoint';
import { planCreateToDto, planFromDto, planListFromDto, planUpdateToDto } from '@/features/agreements/mappers/plansMapper';
import { validateRequiredFields } from '@/shared/utils/validateRequiredFields';

const BASE_ENDPOINT = 'agreements';

const buildServiceEndpoint = ({ agreementId, planId, action } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id: agreementId }, ['plans', planId, action]);
};

export const getPlans = async (agreementId, data = {}) => {
  validateRequiredFields({ agreementId });

  const params = {
    active: data.active,  // Opcional. Si no se proporciona, se retornan todos los planes
  };

  const endpoint = buildServiceEndpoint({ agreementId });
  const response = await api.get(endpoint, { params });
  return response.data.map(planListFromDto);
};

export const createPlan = async (agreementId, data) => {
  validateRequiredFields({ agreementId });

  const payload = planCreateToDto(data);
  const endpoint = buildServiceEndpoint({ agreementId });
  const response = await api.post(endpoint, payload);
  return planFromDto(response.data);
};

export const updatePlan = async (agreementId, planId, data) => {
  validateRequiredFields({ agreementId, planId });

  const payload = planUpdateToDto(data);
  const endpoint = buildServiceEndpoint({ agreementId, planId });
  const response = await api.put(endpoint, payload);
  return planFromDto(response.data);
};

export const activatePlan = async (agreementId, planId) => {
  validateRequiredFields({ agreementId, planId });

  const endpoint = buildServiceEndpoint({ agreementId, planId, action: 'activate' });
  const response = await api.post(endpoint);
  return planFromDto(response.data);
};

/** El endpoint responde con un código 204 (No Content), por lo que no se retorna ningún valor. */
export const deletePlan = async (agreementId, planId) => {
  validateRequiredFields({ agreementId, planId });

  const endpoint = buildServiceEndpoint({ agreementId, planId });
  await api.delete(endpoint);
};
